
import './styles.css';
import { useHistory } from "react-router-dom";

function ProductionChecksheet() {
    
    const history = useHistory();
    
    return (
        <div className='content'>

            <div className="content-menu" >
                <div className="box-menu" onClick={ () => history.push({ pathname: "/d-rec-admin/main/production/checksheet/plan" }) }>
                    <div className="content" style={{ backgroundColor: "rgb(242, 123, 129)" }}>
                        <div className="shot-name">Pl</div>
                        <div className="full-name">Plan</div>
                        <div className="line"></div>
                        <div className="note">Plan management</div>
                    </div>
                </div>
                <div className="box-menu" onClick={ () => history.push({ pathname: "/d-rec-admin/main/production/checksheet/sheet" }) }>
                    <div className="content" style={{ backgroundColor: "rgb(198, 156, 237)" }}>
                        <div className="shot-name">Sh</div>
                        <div className="full-name">Sheet</div>
                        <div className="line"></div>
                        <div className="note">Sheet management</div>
                    </div>
                </div>
                <div className="box-menu" onClick={ () => history.push({ pathname: "/d-rec-admin/main/production/checksheet/group" }) }>
                    <div className="content" style={{ backgroundColor: "rgb(147, 221, 195)" }}>
                        <div className="shot-name">Gr</div>
                        <div className="full-name">Group</div>
                        <div className="line"></div>
                        <div className="note">Equipment Group management</div>
                    </div>
                </div>
                <div className="box-menu" onClick={ () => history.push({ pathname: "/d-rec-admin/main/production/checksheet/enum" }) }>
                    <div className="content" style={{ backgroundColor: "rgb(242, 238, 123)" }}>
                        <div className="shot-name">En</div>
                        <div className="full-name">Enum</div>
                        <div className="line"></div>
                        <div className="note">Enum of Equipment management</div>
                    </div>
                </div>
            </div>
        </div >);
}

export default ProductionChecksheet;